import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ROUTE_PATHS } from './path-map';
import { buildScopedPath, getStoredAccountId } from '../utils/account-context';

/**
 * Cross-tenant Account List removed for tenant isolation.
 * SuperAdmin modifies one account at a time via Super Admin Settings.
 */
export const AdminAccountsListRedirect = () => {
  const accountId = getStoredAccountId();
  if (accountId) {
    return (
      <Navigate
        to={buildScopedPath(accountId, ROUTE_PATHS.superAdminSettings)}
        replace
      />
    );
  }
  return <Navigate to={ROUTE_PATHS.adminAccountsAdd} replace />;
};

export const AdminAccountTenantRedirect = () => {
  const params = useParams();
  const accountId = params.editid || params.viewid;
  if (!accountId) {
    return <AdminAccountsListRedirect />;
  }
  return (
    <Navigate
      to={buildScopedPath(accountId, ROUTE_PATHS.superAdminSettings)}
      replace
    />
  );
};
